// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const clbStepTemplate = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/clb-step-template/clb-step-template.store.js